import { c as _c } from "react-compiler-runtime";
import { forwardRef } from 'react';
import { pickDataAttributes } from '../../utils/pickDataAttributes';
import { SpinnerRoot } from './primitives';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * `Spinner` with a curated props API covering `size`, `variant`, and live-region
 * announcements, without the `xstyle` escape hatch.
 *
 * @see {@link SpinnerRoot | Spinner}
 */
export const Spinner = /*#__PURE__*/forwardRef((t0, ref) => {
  const $ = _c(16);
  const {
    size,
    variant,
    id,
    ariaLabel,
    ariaLabelledby,
    ariaDescribedby,
    ariaDescription,
    dataTestId,
    dataAttributes,
    ariaLive,
    ariaAtomic,
    ariaHidden
  } = t0;
  const t1 = id === null || id === void 0 ? void 0 : id.root;
  const t2 = ariaLabel === null || ariaLabel === void 0 ? void 0 : ariaLabel.root;
  const t3 = ariaLabelledby === null || ariaLabelledby === void 0 ? void 0 : ariaLabelledby.root;
  const t4 = ariaDescribedby === null || ariaDescribedby === void 0 ? void 0 : ariaDescribedby.root;
  const t5 = ariaDescription === null || ariaDescription === void 0 ? void 0 : ariaDescription.root;
  let t6;
  if ($[0] !== dataAttributes) {
    t6 = pickDataAttributes(dataAttributes);
    $[0] = dataAttributes;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  const t7 = dataTestId === null || dataTestId === void 0 ? void 0 : dataTestId.root;
  let t8;
  if ($[2] !== ariaAtomic || $[3] !== ariaHidden || $[4] !== ariaLive || $[5] !== ref || $[6] !== size || $[7] !== t1 || $[8] !== t2 || $[9] !== t3 || $[10] !== t4 || $[11] !== t5 || $[12] !== t6 || $[13] !== t7 || $[14] !== variant) {
    t8 = /*#__PURE__*/_jsx(SpinnerRoot, Object.assign({
      ref: ref,
      size: size,
      variant: variant,
      id: t1,
      "aria-label": t2,
      "aria-labelledby": t3,
      "aria-describedby": t4,
      "aria-description": t5
    }, t6, {
      "data-test-id": t7,
      "aria-live": ariaLive,
      "aria-atomic": ariaAtomic,
      "aria-hidden": ariaHidden
    }));
    $[2] = ariaAtomic;
    $[3] = ariaHidden;
    $[4] = ariaLive;
    $[5] = ref;
    $[6] = size;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
    $[14] = variant;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
});
Spinner.displayName = 'Spinner';